import { useRef } from "react";
import { Form } from "react-bootstrap";
import "./RegistrationMain.css";
import PhoneInput from "../../components/LoginModel/PhoneInput";

const RegistrationMain = () => {
  const phoneInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="container-fluid p-0 regWrap">
      <div className="container ps-md-0 py-2 py-md-5">
        <div className="row justify-content-between">
          {/* LEFT SIDE INFO */}
          <div className="col-md-6 ">
            <div
              className="font-12 ff-semibold text-center glair-wrap bg-3 d-md-flex d-block mx-auto mx-md-0 align-items-center gap-1 px-3 my-3 rounded-pill"
              style={{ width: "fit-content" }}
            >
              <span className="ms-1 glair">Goodhand Journey Starts Here</span>
            </div>

            <h2 className="text-center text-md-start font-35 font-sm-20 text-black ff-bold mb-3">
              Quick, Simple, and Secure <br /> Registration
            </h2>

            <p className="font-14 text-muted mb-0 text-justify">
              Creating your personal Goodhand account is fast, simple, and
              completely secure. In just a few minutes, you can complete your
              registration, set up your preferences, and gain full access to all
              our services designed to make your life easier. Your account will
              serve as your personal hub, allowing you to manage tasks
              efficiently, stay updated with the latest features, and explore
              exclusive tools tailored to your needs. With Goodhand, everything
              you need is in one place, convenient, seamless, and built to save
              you time so you can focus on what matters most. Start your journey
              today and experience a smarter, more connected way to manage your
              personal services.
            </p>
          </div>

          {/* RIGHT SIDE FORM */}
          <div className="col-md-5 p-0 ">
            <div className="p-4 reg-frm-main">
              <h4 className="ff-bold text-center text-md-start mb-3 font-25 font-sm-18">
                Register With{" "}
                <span className="text-main ff-bold">Goodhand</span>
              </h4>

              <Form>
                <div className="row up-form">
                  {/* First Name */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                      />
                      <Form.Label
                        htmlFor="firstName"
                        className="ff-semibold text-black-50"
                      >
                        First Name
                      </Form.Label>
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                      />
                      <Form.Label
                        htmlFor="lastName"
                        className="ff-semibold text-black-50"
                      >
                        Last Name
                      </Form.Label>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-12 ">
                    <div className="form-group mt-2 position-relative unique-verifiable">
                      <PhoneInput
                        placeholder="Phone Number"
                        phoneInputRef={phoneInputRef}
                        phoneNumber=""
                        countryCode="+971" onPhoneNumberChange={function (): void {
                          throw new Error("Function not implemented.");
                        } } onCountryCodeChange={function (): void {
                          throw new Error("Function not implemented.");
                        } }                      />
                      <div className="verification-box d-flex align-items-center">
                        <span className="text-success font-12 ff-semibold me-2">
                          <i className="bi bi-check-circle-fill me-1" />{" "}
                          Verified
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-12 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Email Address"
                      />
                      <Form.Label
                        htmlFor="email"
                        className="ff-semibold text-black-50"
                      >
                        Email Address
                      </Form.Label>
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="date"
                        name="dateOfBirth"
                        placeholder="Date of Birth"
                        max={new Date().toISOString().split("T")[0]}
                      />
                      <Form.Label
                        htmlFor="dateOfBirth"
                        className="ff-semibold text-black-50"
                      >
                        Date of Birth
                      </Form.Label>
                    </div>
                  </div>

                  {/* Photo Upload */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="file"
                        id="photoUpload"
                        name="photoUpload"
                      />
                      <Form.Label
                        htmlFor="photoUpload"
                        className="ff-semibold text-black-50"
                      >
                        Attach / Drag Photo
                      </Form.Label>
                    </div>
                  </div>

                  {/* Passport Number */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Control
                        type="text"
                        name="passportNumber"
                        placeholder="Passport Number"
                      />
                      <Form.Label
                        htmlFor="passportNumber"
                        className="ff-semibold text-black-50"
                      >
                        Passport Number
                      </Form.Label>
                    </div>
                  </div>

                  {/* Nationality */}
                  <div className="col-md-6 mb-3">
                    <div className="form-group mt-2">
                      <Form.Select name="nationality">
                        <option value="">Select Nationality</option>
                        <option value="UAE">United Arab Emirates</option>
                        <option value="India">India</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Egypt">Egypt</option>
                        <option value="Other">Other</option>
                      </Form.Select>
                      <Form.Label
                        htmlFor="nationality"
                        className="ff-semibold text-black-50"
                      >
                        Nationality
                      </Form.Label>
                    </div>
                  </div>
                </div>

                {/* Terms Checkbox */}
                <div className="d-flex align-items-start gap-2 mt-2">
                  <Form.Check type="checkbox" id="terms" />
                  <label htmlFor="terms" className="font-13 text-muted">
                    I’ve read and agree with{" "}
                    <a href="#" className="text-main">
                      terms of service
                    </a>{" "}
                    and our{" "}
                    <a href="#" className="text-main">
                      privacy policy
                    </a>
                    .
                  </label>
                </div>

                {/* Register Button */}
                <div className="text-center d-flex justify-content-center justify-content-md-start   col-12 mt-3 mb-md-3 mb-2">
                  <button
                    className="btn btn-primary rounded-pill shadow-sm text-white bg-main w-50 font-14 ff-semibold bt--cart"
                    type="button"
                  >
                    Register{" "}
                  </button>
                </div>

                {/* Sign In Link */}
                <div className="text-center text-md-start font-13">
                  Already have an account?{" "}
                  <a href="#" className="text-main ff-semibold">
                    Sign in
                  </a>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationMain;
